<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto mb-5 contract-management-module">
  <div style="padding-left: 15px" class="col-12 no-gutters">
    <app-layout-header [isContractManagementModule]="true" class="col-12 no-gutters"></app-layout-header>
  </div>
  <div class="col-12 no-gutters row image-container">
    <img 
      class="img-fluid w-100 h-100 contract-management-banner" 
      src="assets/images/hydro-contract-management-banner.jpg"
      alt="banner" 
    />
    <div class="description">
      <h3>Hydro DocStore</h3>
      <p>The central repository for contracts and other documents relating to suppliers of GE Vernova Hydro Solutions.</p>
    </div>
  </div>
  <div class="mt-3 col-12">
    <div class="box-title-module row clearfix">
      <div class="col-xl-5 d-flex flex-row align-items-center justify-content-start">
        <span class="module-name mr-3">DocStore</span>
        <div>
          <a class="btn mr-1" [routerLink]="['/', PATH_ROUTING.PATH_DOCSTORE]" [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }">
            Home
          </a>
          <ng-container *ngIf="!isInCreateScreen">
            <a *ngIf="!isLoginUserViewer()" class="btn"
              [routerLink]="['/', PATH_ROUTING.PATH_DOCSTORE, PATH_ROUTING.PATH_CREATE_CONTRACT]"
              [routerLinkActive]="'active'">
              Upload New Document
            </a>
          </ng-container>
        </div>
      </div>
      <div class="col-xl-7 d-flex flex-row align-items-center justify-content-end">
        <span class="link-title mr-1">Useful Links</span>
        <a class="btn px-3 ml-1" href="https://www.gesupplierconnect.com/sc/home" target="_blank">Supplier Connect</a>
        <a class="btn px-3 ml-1" href="https://prod-tableau-cloud.ren.apps.ge.com/#/site/REN/views/Hydro_Supplier_Panel/HydroDS-SupData?:iid=1" target="_blank">Hydro Supplier Panel Dashboard</a>
        <a class="btn px-3 ml-1" href="https://app.sc.ge.com/forms/var/records/870426" target="_blank">Supplier Qualifications</a>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer-layout></app-footer-layout>